<template>
    <user-documents v-if="!isMediaOpen" @open-media="showMedia" />
    <document-show v-else :mediaBase64="mediaAsBase64" @close="closeMedia()" />
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import UserDocuments from "./UserDocuments.vue";
import DocumentShow from "./DocumentShow.vue";
import { ref } from "vue";
import { useStore } from "vuex";
import { HELPER_TYPES, MEDIA_TYPES, STORE_TYPES } from "../../store/types";

export default defineComponent({
    components: { UserDocuments, DocumentShow },
    setup() {
        const store = useStore();
        const isMediaOpen = ref(false);
        const mediaAsBase64 = ref("");
        function showMedia(media) {
            fetchMediaAsBase64(media);
        }
        async function fetchMediaAsBase64(mediaDoc) {
            console.log(mediaDoc);
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                `open-media-button-${mediaDoc.id}`
            );
            const response = await store.dispatch(
                `${STORE_TYPES.MEDIA}/${MEDIA_TYPES.FETCH_MEDIA_AS_BASE}`,
                {
                    media: { id: mediaDoc.id },
                }
            );
            console.log(response.data);
            if (response.data) {
                mediaAsBase64.value = response.data;
                isMediaOpen.value = true;
            }
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                `open-media-button-${mediaDoc.id}`
            );
        }
        function closeMedia() {
            isMediaOpen.value = false;
            mediaAsBase64.value = "";
        }
        return { isMediaOpen, showMedia, mediaAsBase64, closeMedia };
    },
});
</script>
